export const ATTACHMENTS_ONLY_BODY_PLACEHOLDER = '[media]';

const ATTACHMENTS_ONLY_BODY_SENTINELS = new Set([
    ATTACHMENTS_ONLY_BODY_PLACEHOLDER,
]);

export const isAttachmentsOnlyBodyPlaceholder = (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    return ATTACHMENTS_ONLY_BODY_SENTINELS.has(value.trim());
};

export const normalizePostBody = (value) => {
    if (typeof value !== 'string') {
        return '';
    }
    return isAttachmentsOnlyBodyPlaceholder(value) ? '' : value;
};

export const resolveAttachmentsOnlyBody = (allowEmpty) => (
    allowEmpty ? '' : ATTACHMENTS_ONLY_BODY_PLACEHOLDER
);
